import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'term',
    label: 'Extension Term',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'amount',
    label: 'Extension Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'llpaType',
    label: 'LLPA Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const addExtensionForm = {
  name: FormNames.ADD_EXTENSION,
  label: 'Add Extension',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
